<template>

<div id="about-container">
  <BackComponent />
  <div id="about" v-html="$i18n.t('galleryAbout')"></div>

</div>

</template>



<script>

import {loadLocaleMessages} from "../i18n.js";
import BackComponent from "./BackComponent.vue";
export default { 
  name: "AboutPage",
  components: {
    BackComponent: BackComponent,
  },
  data() {
    return {
      dxaFull: process.env.VUE_APP_DXA_FULL,
    }
  },
  // Load i18n messages in correct language
  beforeRouteEnter(to, from, next) {
    loadLocaleMessages("en").then(() => next()); 
  },
  beforeRouteUpdate(to, from, next) {
    loadLocaleMessages("en").then(() => next());
  }
}

</script>



<style scoped lang="scss">

#about-container {
  @include flex-center;
  flex-direction: column;
  background-color: white;
  width: 100%;
}
  #about {
    width: 50%;
    padding: 0 50px 50px 50px;
  }
    #about a {
      @include link-styles;
    }
      #about a:hover {
        @include link-hover-styles;
      }
  
@media only screen and (max-width: 1199px) {
  #about {
    width: 70%;
  }
}

@media only screen and (max-width: 974px) {
  #about {
    width: 80%;
  }
}

@media only screen and (max-width: 849px) {
  #about {
    width: 88%;
  }
}

@media only screen and (max-width: 724px) {
  #about {
    width: 100%;
  }
}

@media only screen and (max-width: 599px) {
  #about {
    padding: 0 30px 30px 30px;
  }
}

</style>